/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { HttpParams } from "@angular/common/http";
import { GET_CONFIGURATION_BY_TENANT } from "./dashboard-config.db";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class DashboardConfig {
	public static getConfigurationByTenant(options: HttpRequestOptions) {
		const { params } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.getConfigurationByTenant.name
					)
			);

		const tenantId = httpParams.get("tenantId");

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						this.constructor.name,
						this.getConfigurationByTenant.name
					)
			);

		return of(GET_CONFIGURATION_BY_TENANT);
	}
}
